import getSliceName from '@om-fe/core/utils/get-slice-name';
import { DisciplinesType } from '@om-fe/models';
import {
    ALL_LOCATIONS,
    LIVE_MATCH_AGGREGATOR_PATH,
    LIVE_ESPORTS_MATCH_AGGREGATOR_PATH,
    LIVE_GROUPS_MATCH_AGGREGATOR_PATH,
    LIVE_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH,
    LIVE_MATCH_AGGREGATOR_PATH_ALL_SPORTS,
    LIVE_GROUPS_MATCH_AGGREGATOR_PATH_ALL_SPORTS,
    LIVE_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH_ALL_SPORTS,
    LIVE_MATCH_AGGREGATOR_PATH_BY_CATEGORIES,
    LIVE_GROUPS_MATCH_AGGREGATOR_PATH_BY_CATEGORIES,
    LIVE_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH_BY_CATEGORIES,
    LIVE_MATCH_AGGREGATOR_PATH_NO_ODDS,
    LIVE_GROUPS_MATCH_AGGREGATOR_PATH_NO_ODDS,
    LIVE_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH_NO_ODDS,
    LiveMatchListNoOddsTopicModel,
    LiveMatchListTopicModel,
    slicePrefix,
    LIVE_GROUPS_OVERVIEW_ESPORTS_MATCH_AGGREGATOR_PATH,
} from './live-match-list.constants';
import { getMatchListNrOfMarkets } from '../../utils/match-list.utils';
import { LiveMatchListPublicProps } from './live-match-list';
import * as shallowEqual from 'shallowequal';

export function getLiveMatchListSliceName(instanceId: string): string {
    return getSliceName(slicePrefix, instanceId);
}

export function getLiveGroupsMatchListSliceName(instanceId: string): string {
    return getSliceName(`${slicePrefix}-group`, instanceId);
}

export function getLiveMatchListTopic(
    disciplineId: string,
    limit: number,
    locationId?: string,
    isDefault?: boolean,
    mainMarketsLimit?: number,
    eventCategoryId?: string,
    allSports?: boolean,
    noOdds?: boolean,
    isAuthenticated?: boolean,
): LiveMatchListTopicModel | LiveMatchListNoOddsTopicModel {
    if (noOdds) {
        if (allSports) {
            let topic: string = LIVE_MATCH_AGGREGATOR_PATH_ALL_SPORTS;

            topic = `${topic}/all-locations`;
            topic = !isDefault ? `${topic}/default-event-info` : topic;
            topic = isAuthenticated ? `${topic}/logged-in-users` : topic;
            topic = limit ? `${topic}/:limitNumberOfEvents` : topic;
            topic = `${topic}/no-odds`;

            return {
                path: topic,
                params: {
                    limitNumberOfEvents: limit,
                },
            };
        } else {
            let topic: string = LIVE_MATCH_AGGREGATOR_PATH_NO_ODDS;

            topic = !isDefault ? `${topic}/default-event-info` : topic;
            topic = isAuthenticated ? `${topic}/logged-in-users` : topic;
            topic = limit ? `${topic}/:limitNumberOfEvents` : topic;
            topic = `${topic}/no-odds`;

            return {
                path: topic,
                params: {
                    isChildren: true,
                    disciplineId,
                    limitNumberOfEvents: limit,
                },
            };
        }
    } else {
        if (eventCategoryId) {
            let topic: string = LIVE_MATCH_AGGREGATOR_PATH_BY_CATEGORIES;
            topic = !isDefault ? `${topic}/default-event-info` : topic;
            topic = isAuthenticated ? `${topic}/logged-in-users` : topic;
            topic = limit ? `${topic}/:limitNumberOfEvents` : topic;
            topic = `${topic}/:nrOfMarkets`;

            const nrOfMarkets: number = getMatchListNrOfMarkets(mainMarketsLimit);

            return {
                path: topic,
                params: {
                    eventCategoryId: eventCategoryId || ALL_LOCATIONS,
                    nrOfMarkets,
                    limitNumberOfEvents: limit,
                },
            };
        } else {
            let topic: string = LIVE_MATCH_AGGREGATOR_PATH;

            if (disciplineId === DisciplinesType.ElectronicSports) {
                topic = LIVE_ESPORTS_MATCH_AGGREGATOR_PATH;
                topic = !isDefault ? `${topic}/all-locations/default-event-info` : `${topic}/all-locations`;
            } else {
                topic = !isDefault ? `${topic}/default-event-info` : topic;
            }
            topic = isAuthenticated ? `${topic}/logged-in-users` : topic;
            topic = limit ? `${topic}/:limitNumberOfEvents` : topic;
            topic = `${topic}/:nrOfMarkets`;

            const nrOfMarkets: number = getMatchListNrOfMarkets(mainMarketsLimit);

            return {
                path: topic,
                params: {
                    disciplineId: disciplineId === DisciplinesType.ElectronicSports ? undefined : disciplineId,
                    locationId: locationId || ALL_LOCATIONS,
                    nrOfMarkets,
                    limitNumberOfEvents: limit,
                },
            };
        }
    }
}

export function getLiveGroupsMatchListTopic(
    disciplineId: string,
    limit: number,
    locationId?: string,
    isDefault?: boolean,
    mainMarketsLimit?: number,
    eventCategoryId?: string,
    allSports?: boolean,
    noOdds?: boolean,
    marketGroupsOverviewNumber?: number,
    isAuthenticated?: boolean,
): LiveMatchListTopicModel | LiveMatchListNoOddsTopicModel {
    if (noOdds) {
        if (allSports) {
            let topic: string = LIVE_GROUPS_MATCH_AGGREGATOR_PATH_ALL_SPORTS;

            topic = `${topic}/all-locations`;
            topic = !isDefault ? `${topic}/default-event-info` : topic;
            topic = isAuthenticated ? `${topic}/logged-in-users` : topic;
            topic = limit ? `${topic}/:limitNumberOfEvents` : topic;
            topic = `${topic}/no-odds`;

            return {
                path: topic,
                params: {
                    limitNumberOfEvents: limit,
                },
            };
        } else {
            let topic: string = LIVE_GROUPS_MATCH_AGGREGATOR_PATH_NO_ODDS;

            topic = !isDefault ? `${topic}/default-event-info` : topic;
            topic = isAuthenticated ? `${topic}/logged-in-users` : topic;
            topic = limit ? `${topic}/:limitNumberOfEvents` : topic;
            topic = `${topic}/no-odds`;

            return {
                path: topic,
                params: {
                    isChildren: true,
                    disciplineId,
                    limitNumberOfEvents: limit,
                },
            };
        }
    } else {
        if (eventCategoryId) {
            let topic: string = LIVE_GROUPS_MATCH_AGGREGATOR_PATH_BY_CATEGORIES;
            topic = !isDefault ? `${topic}/default-event-info` : topic;
            topic = isAuthenticated ? `${topic}/logged-in-users` : topic;
            topic = limit ? `${topic}/:limitNumberOfEvents` : topic;
            topic = `${topic}/:nrOfMarkets`;

            const nrOfMarkets: number = getMatchListNrOfMarkets(mainMarketsLimit);

            return {
                path: topic,
                params: {
                    eventCategoryId: eventCategoryId || ALL_LOCATIONS,
                    nrOfMarkets: marketGroupsOverviewNumber ?? nrOfMarkets,
                    limitNumberOfEvents: limit,
                },
            };
        } else {
            let topic: string = LIVE_GROUPS_MATCH_AGGREGATOR_PATH;

            topic = !isDefault ? `${topic}/default-event-info` : topic;
            topic = isAuthenticated ? `${topic}/logged-in-users` : topic;
            topic = limit ? `${topic}/:limitNumberOfEvents` : topic;
            topic = `${topic}/:nrOfMarkets`;

            const nrOfMarkets: number = getMatchListNrOfMarkets(mainMarketsLimit);

            return {
                path: topic,
                params: {
                    disciplineId,
                    locationId: locationId || ALL_LOCATIONS,
                    nrOfMarkets: marketGroupsOverviewNumber ?? nrOfMarkets,
                    limitNumberOfEvents: limit,
                },
            };
        }
    }
}

export function getLiveGroupsOverviewMatchListTopic(
    disciplineId: string,
    limit: number,
    locationId?: string,
    isDefault?: boolean,
    mainMarketsLimit?: number,
    eventCategoryId?: string,
    marketGroupsOverviewIds?: string,
    allSports?: boolean,
    noOdds?: boolean,
    isAuthenticated?: boolean,
): LiveMatchListTopicModel | LiveMatchListNoOddsTopicModel {
    if (noOdds) {
        if (allSports) {
            let topic: string = LIVE_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH_ALL_SPORTS;

            topic = `${topic}/all-locations`;
            topic = !isDefault ? `${topic}/default-event-info` : topic;
            topic = isAuthenticated ? `${topic}/logged-in-users` : topic;
            topic = limit ? `${topic}/:limitNumberOfEvents` : topic;
            topic = `${topic}/no-odds`;

            return {
                path: topic,
                params: {
                    limitNumberOfEvents: limit,
                },
            };
        } else {
            let topic: string = LIVE_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH_NO_ODDS;

            topic = !isDefault ? `${topic}/default-event-info` : topic;
            topic = isAuthenticated ? `${topic}/logged-in-users` : topic;
            topic = limit ? `${topic}/:limitNumberOfEvents` : topic;
            topic = `${topic}/no-odds`;

            return {
                path: topic,
                params: {
                    isChildren: true,
                    disciplineId,
                    limitNumberOfEvents: limit,
                },
            };
        }
    } else {
        if (eventCategoryId) {
            let topic: string = LIVE_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH_BY_CATEGORIES;
            topic = !isDefault ? `${topic}/default-event-info` : topic;
            topic = isAuthenticated ? `${topic}/logged-in-users` : topic;
            topic = limit ? `${topic}/:limitNumberOfEvents` : topic;
            topic = `${topic}/:marketGroupsOverviewIds`;

            return {
                path: topic,
                params: {
                    eventCategoryId: eventCategoryId || ALL_LOCATIONS,
                    limitNumberOfEvents: limit,
                    marketGroupsOverviewIds
                },
            };
        } else {
            let topic: string = LIVE_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH;

            if (disciplineId === DisciplinesType.ElectronicSports) {
                topic = LIVE_GROUPS_OVERVIEW_ESPORTS_MATCH_AGGREGATOR_PATH;
                topic = !isDefault ? `${topic}/all-locations/default-event-info` : `${topic}/all-locations`;
            } else {
                topic = !isDefault ? `${topic}/default-event-info` : topic;
            }
            topic = isAuthenticated ? `${topic}/logged-in-users` : topic;
            topic = limit ? `${topic}/:limitNumberOfEvents` : topic;
            topic = `${topic}/:marketGroupsOverviewIds`;

            const nrOfMarkets: number = getMatchListNrOfMarkets(mainMarketsLimit);

            return {
                path: topic,
                params: {
                    disciplineId: disciplineId === DisciplinesType.ElectronicSports ? undefined : disciplineId,
                    locationId: locationId || ALL_LOCATIONS,
                    nrOfMarkets,
                    limitNumberOfEvents: limit,
                    marketGroupsOverviewIds,
                },
            };
        }
    }
}

interface LiveMatchListTopicProps {
    readonly disciplineId: string;
    readonly locationId?: string;
    readonly eventCategoryId?: string;
    readonly limitNumberOfEvents?: number;
    readonly mainMarketsLimit?: number;
    readonly isDefault?: boolean;
}

const getTopicProps = (props: LiveMatchListPublicProps): LiveMatchListTopicProps => ({
    disciplineId: props.disciplineId,
    locationId: props.locationId,
    eventCategoryId: props.eventCategoryId,
    limitNumberOfEvents: props.limitNumberOfEvents,
    mainMarketsLimit: props.mainMarketsLimit,
    isDefault: props.isDefault,
});

export function areLiveMatchListTopicPropsEqual(
    prevProps: LiveMatchListPublicProps,
    newProps: LiveMatchListPublicProps,
): boolean {
    return shallowEqual(getTopicProps(prevProps), getTopicProps(newProps));
}

const getTopicESportProps = (props: LiveMatchListPublicProps): LiveMatchListTopicProps => ({
    disciplineId: props.disciplineId,
    eventCategoryId: props.eventCategoryId,
    limitNumberOfEvents: props.limitNumberOfEvents,
    mainMarketsLimit: props.mainMarketsLimit,
    isDefault: props.isDefault,
});

export function areLiveMatchListTopicESportPropsEqual(
    prevProps: LiveMatchListPublicProps,
    newProps: LiveMatchListPublicProps,
): boolean {
    return shallowEqual(getTopicESportProps(prevProps), getTopicESportProps(newProps));
}
